import React, { Suspense, lazy } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import Loading from "./Loading";
import Layout from "./Layout/Layout";
import { FixturesProvider } from "./Layout/Menu/FixturesProvider";
import ErrorBoundary from "./ErrorBoundary";

const LazySettings = lazy(() => import("../pages/settings"));
const LazyOperatorSettings = lazy(() => import("../pages/operatorSettings"));
const LazyBetMonitor = lazy(() => import("../pages/betMonitor"));
const LazyEventManagement = lazy(() => import("../pages/eventManagement"));
const LazyEventWeekManagement = lazy(() =>
  import("../pages/eventWeekManagement"),
);
const LazyLogin = lazy(() => import("../pages/login"));
const LazyNotFound = lazy(() => import("../pages/404"));
const LazyDataLookup = lazy(() => import("../pages/dataLookup"));
const LazyPlayerIndex = lazy(() => import("../pages/playerIndex"));
const LazyPriceRules = lazy(() => import("../pages/priceRules"));
const LazyServiceMonitoring = lazy(() => import("../pages/serviceMonitoring"));

const routes = [
  {
    path: "/",
    exact: true,
    main: () => (
      <FixturesProvider>
        <LazyEventManagement />
      </FixturesProvider>
    ),
  },
  // {
  //   path: "/event-week-management/nfl",
  //   exact: true,
  //   title: "Event Week Fixtures",
  //   main: () => <Redirect to="/event-week-management/001/001/events" />,
  // },
  {
    path: "/bet-monitor",
    exact: true,
    title: "Bet Monitor",
    main: () => <LazyBetMonitor />,
  },
  {
    path: "/event-management/:id/events",
    exact: true,
    title: "Event Management",
    main: () => (
      <FixturesProvider>
        <LazyEventManagement />
      </FixturesProvider>
    ),
  },
  {
    path: "/event-management/:id/lineups",
    exact: true,
    title: "Event Management",
    main: () => (
      <FixturesProvider>
        <LazyEventManagement view="lineups" />
      </FixturesProvider>
    ),
  },
  {
    path: "/event-management/:id/stats",
    exact: true,
    title: "Event Management",
    main: () => (
      <FixturesProvider>
        <LazyEventManagement view="stats" />
      </FixturesProvider>
    ),
  },
  {
    path: "/event-management/:id/log",
    exact: true,
    title: "Event Management",
    main: () => (
      <FixturesProvider>
        <LazyEventManagement view="log" />
      </FixturesProvider>
    ),
  },
  {
    path: "/event-management/:id/combo-view",
    exact: true,
    title: "Event Management",
    main: () => (
      <FixturesProvider>
        <LazyEventManagement view="combo-view" />
      </FixturesProvider>
    ),
  },
  {
    path: "/event-week-management/:id/:date/events",
    exact: true,
    title: "Event Management NFL",
    main: () => <LazyEventWeekManagement />,
  },
  {
    path: "/event-week-management/:id/:date/lineups",
    exact: true,
    title: "Event Management",
    main: () => <LazyEventWeekManagement view="lineups" />,
  },
  {
    path: "/event-week-management/:id/:date/stats",
    exact: true,
    title: "Event Management",
    main: () => <LazyEventWeekManagement view="stats" />,
  },
  {
    path: "/event-week-management/:id/:date/log",
    exact: true,
    title: "Event Management",
    main: () => <LazyEventWeekManagement view="log" />,
  },
  {
    path: "/data-lookup",
    exact: true,
    title: "Data Lookup",
    main: () => <LazyDataLookup view="log" />,
  },
  {
    path: "/settings",
    exact: true,
    title: "Settings",
    main: () => <LazySettings />,
  },
  {
    path: "/operator-settings/:id",
    exact: true,
    title: "Team Rosters",
    main: () => <LazyOperatorSettings />,
  },
  {
    path: "/player-index/:id",
    exact: true,
    title: "Player index",
    main: () => <LazyPlayerIndex />,
  },
  {
    path: "/price-rules/:id",
    exact: true,
    title: "Price rules",
    main: () => <LazyPriceRules />,
  },
  {
    path: "/service-monitoring",
    exact: true,
    title: "Service Monitoring",
    main: () => <LazyServiceMonitoring />,
  },
  {
    path: "*",
    title: "Page Not Found",
    main: () => <LazyNotFound />,
  },
];

const fullPageroutes = [
  {
    path: "/login",
    main: () => <LazyLogin />,
  },
];

const Router = () => {
  return (
    <BrowserRouter>
      <Switch>
        {fullPageroutes.map((route) => (
          <Route
            key={route.path}
            path={route.path}
            exact={route.exact}
            children={
              <Suspense fallback={<Loading />}>
                <route.main />
              </Suspense>
            }
          ></Route>
        ))}
        <Route>
          <Layout routes={routes}>
            <Switch>
              {routes.map((route) => (
                <Route
                  key={route.path}
                  path={route.path}
                  exact={route.exact}
                  children={
                    <ErrorBoundary>
                      <Suspense fallback={<Loading />}>
                        <route.main />
                      </Suspense>
                    </ErrorBoundary>
                  }
                ></Route>
              ))}
            </Switch>
          </Layout>
        </Route>
      </Switch>
    </BrowserRouter>
  );
};

export default Router;
